export default __webpack_public_path__ + "static/indian2-e66f731fb37914222a9a43eaf529b240.jpg";